import dayjs from 'dayjs'
import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useNavigate, useParams } from 'react-router-dom'
import { treinamentos } from 'service/api'
import { toast } from 'sonner'
import { useTreinamentosOutletContext } from 'templates/Admin/Clientes/atoms/Pages/Cobrancas.context'

export default function ExcluirTreinamento() {
    const navigate = useNavigate()
    const { treinamentoId } = useParams()
    const { data, clienteId } = useTreinamentosOutletContext()
    const treinamento = data.find(item => item.id === Number(treinamentoId))

    const { mutateAsync, isLoading } = treinamentos.mutations.useDelete({
        invalidateQuery: true,
        queryParams: { clienteId: String(clienteId) },
    })

    if (!treinamento) return null

    const handleSubmit = () =>
        mutateAsync(treinamento.id, {
            onSuccess: () => {
                toast.success('Treinamento excluído com sucesso!')
                navigate(-1)
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <ConfirmarExclusao
            permissao={['delete', 'Treinamentos']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title={
                <>
                    Realmente deseja excluir o treinamento de{' '}
                    {dayjs(treinamento.data).format('DD/MM/YYYY HH:mm')}{' '}
                    recebido por {treinamento.quemRecebeu}?
                </>
            }
        />
    )
}
